import { TEMPLATES } from "../templates/catalog.ts";

/**
 * Modal som visar mall-galleriet. Används från DocumentSwitcher när
 * användaren klickar "+ Ny central". Väljer man en mall (eller "Tom
 * central") anropas onPick med template-nyckeln, eller null för tomt.
 */
export function TemplateGallery({
  onPick,
  onClose,
}: {
  onPick: (templateKey: string | null) => void;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50"
      role="dialog"
      aria-label="Välj mall för ny central"
      onClick={onClose}
    >
      <div
        className="max-h-[85vh] w-full max-w-3xl overflow-auto rounded-lg bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold">Ny central</h2>
            <p className="text-sm text-slate-500">
              Välj en mall för att komma igång snabbare — eller börja från en
              tom central.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded px-2 py-1 text-slate-500 hover:bg-slate-100"
            aria-label="Stäng"
          >
            ×
          </button>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          <TemplateCard
            title="Tom central"
            description="Börja med en blank panel — ingen förkonfigurering."
            rows={0}
            sections={0}
            onPick={() => onPick(null)}
          />
          {TEMPLATES.map((t) => {
            const rowCount = t.sections.reduce(
              (sum, s) => sum + s.rows.length,
              0,
            );
            return (
              <TemplateCard
                key={t.key}
                title={t.name}
                description={t.description}
                rows={rowCount}
                sections={t.sections.length}
                onPick={() => onPick(t.key)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

function TemplateCard({
  title,
  description,
  rows,
  sections,
  onPick,
}: {
  title: string;
  description: string;
  rows: number;
  sections: number;
  onPick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onPick}
      className="flex flex-col gap-2 rounded-lg border border-slate-200 bg-white p-4 text-left hover:border-sky-400 hover:bg-sky-50"
    >
      <span className="text-base font-semibold">{title}</span>
      <span className="text-sm text-slate-600">{description}</span>
      <span className="mt-auto text-xs text-slate-400">
        {sections === 0 && rows === 0
          ? "tom central"
          : `${sections} sektion${sections === 1 ? "" : "er"} · ${rows} rader`}
      </span>
    </button>
  );
}
